var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"open-delay":"300","top":""},scopedSlots:_vm._u([{key:"activator",fn:function({on, attrs}){return [_c('v-icon',_vm._g(_vm._b({attrs:{"size":"18"}},'v-icon',attrs,false),on),[_vm._v(" $question-outlined ")])]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }